import { useState } from "react";

import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

import axios from "../axios";
import PdfViewer from "./PdfViewer";
import "./css/pdf-form.css";

function PdfForm() {
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [files, setFiles] = useState([]);
  const [mergeFilePath, setMergeFilePath] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);

  // change the state of files only if both the files are selected
  function handleInputPdfFirst(e) {
    const fileone = e.target.files[0];

    if (file2 !== null) {
      setFiles([fileone, file2]);
    }

    setFile1(fileone);
    setMergeFilePath(null);
  }
  // change the state of files only if both the files are selected

  function handleInputPdfSecond(e) {
    const filetwo = e.target.files[0];

    if (file1 !== null) {
      setFiles([file1, filetwo]);
    }

    setFile2(filetwo);
    setMergeFilePath(null);
  }

  function submitFiles() {
    // find the count of files if < 1 alert the user whether select two files
    if (files.length !== 2) {
      alert("Select 2 files to merge");
      return;
    }

    // set the loading button animation true
    setLoadingButton(true);

    // now pass this seleted pdf files to the server
    // append all the selected pdf files in formData and make a post request to server

    let formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });

    // post the data to the server
    axios
      .post("/merge", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const filename = response.data.filename;
        setMergeFilePath(`${axios.defaults.baseURL}/pdf/${filename}.pdf`);
        setLoadingButton(false);
      })
      .catch((error) => console.log(`error occured ${error}`));
  }

  return (
    <div>
      <div className="pdf-form">
        <div>
          <h1>Select The Pdf Files You want to merge </h1>
        </div>
        <div>
          <Form.Group controlId="formFileLg" className="mb-3 m-3">
            <Form.Control
              type="file"
              size="lg"
              // multiple
              accept="application/pdf"
              onChange={handleInputPdfFirst}
            />
          </Form.Group>
          <Form.Group controlId="formFileLg" className="mb-3 m-3">
            <Form.Control
              type="file"
              size="lg"
              // multiple
              accept="application/pdf"
              onChange={handleInputPdfSecond}
            />
          </Form.Group>
        </div>
        <div>
          {!loadingButton ? (
            <Button variant="primary" size="lg" active onClick={submitFiles}>
              Submit
            </Button>
          ) : (
            <Spinner animation="border" variant="primary" />
          )}
        </div>
      </div>

      {mergeFilePath && <PdfViewer mergeFilePath={mergeFilePath} />}
    </div>
  );
}

export default PdfForm;
